import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class ProspectusDataService {
  abstract getAllProspectuses(variables: any): { query: any; variables: any };
  abstract getProspectusForMonitoring(variables: any): { query: any; variables: any };
  abstract addProspectus(variables: any): { mutation: any; variables: any };
  abstract updateProspectus(variables: any): { mutation: any; variables: any };
  abstract closeProspectus(variables: any): { mutation: any; variables: any };
  abstract openProspectus(variables: any): { mutation: any; variables: any };
  abstract getCrops(): { query: any };
  abstract getVarieties(variables: any): { query: any; variables: any };
  abstract setProspectusVariety(variables: any): { mutation: any; variables: any };
  abstract setFarmProductionCategory(variables: any): { mutation: any; variables: any };
  abstract setFarmNurseryCategory(variables: any): { mutation: any; variables: any };
  abstract getHarvests(variables: any): { query: any; variables: any };
  abstract addHarvests(variables: any): { mutation: any; variables: any };
  abstract deleteProspectusHeavests(variables: any): { mutation: any; variables: any };
  abstract addProspectusMap(variables: any): { mutation: any; variables: any };
  abstract deleteProspectusMap(variables: any): { mutation: any; variables: any };
  abstract setSoilTextureTechnique(variables: any): Observable<any>;
  abstract setSoillessSubstrateTechnique(variables: any): Observable<any>;
  abstract getSoilTextureClassifications(): any;
  abstract getSoillessSubstrateTypes(): any;
  abstract getDestinationPlants(): any;
  abstract getTotalExtensionByCompany(company: string): any;
  abstract getProspectusesGps(variables: any): { query: any; variables: any };
  abstract getMonitoringProd(variables: { serials: string[]; limit?: number; offset?: number }): { query: any; variables: any };
  abstract getMonitoringNursery(variables: { serials: string[]; limit?: number; offset?: number }): { query: any; variables: any };
}
